<template>
    <div style="padding:1px;">
    <hd></hd>
    <div class="snatched">
        <div class="toggleList">
          <div class="toggleGroup">
            <div class="toggle">
                <el-select class="" v-model="area" clearable placeholder="请选商家所在地" @change="changeArea" >
                  <el-option
                    v-for="item in COUNTRIES"
                    :key="item.value"
                    :label="item.name+'('+item.value+')'"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            <div class="toggle">
                <el-select class="" v-model="currency" clearable placeholder="请选择商家货币" @change="changeCurrency">
                  <el-option
                    v-for="item in CURRENCIES"
                    :key="item.value"
                    :label="item.name+'('+item.value+')'"
                    :value="item.value">
                  </el-option>
                </el-select>
            </div>
            <div class="toggle">
                <el-autocomplete
                class="inline-input"
                v-model="business"
                :fetch-suggestions="querySearch"
                placeholder="请输入商家名称"
                :trigger-on-focus="false"
                @select="handleSelect"
                ></el-autocomplete>
            </div>
            <div v-if="single_type=='1'" class="warningWrapper">
                <i title="接单提醒" @click="switchVolumn" class="iconfont volumn" :class="{'el-icon-joyordervolumn':volumnOn,'el-icon-joyordervolumn-mute':!volumnOn}"></i>
            </div>
          </div>
            <div style="display:flex;align-items: center;" class="button">
                <div class="refresh" @click="refresh()">
                    <div class="refreshIcon" :class="rotate?'rotate':''"></div>
                    换一批
                </div>
            </div>
        </div>
        <div class="titleList" v-if="poolList.length > 0 && !mobiletype" >
            <div class="title" style="margin-right:168px;margin-left:10px">商家</div>
            <div class="title" style="margin-right:106px">金额 * 汇率</div>
            <div class="title" style="margin-right:125px">收货信息</div>
            <div class="title" style="">响应时间</div>
            <div class="title" style="float: right;margin-right:30px">状态</div>
        </div>
        <div class="empty" v-if="poolList.length == 0">
            <Empty class="empty-content" title="待抢任务"></Empty>
        </div>
        <div v-else class="pool">
            <dd v-if="loading" class="text-center">
                <Loading></Loading>
            </dd>
            <el-collapse v-model="activeName" accordion @change="handleAccord">
                <el-collapse-item v-for="(item,index) in poolList" :key="index" class="" :name="index">
                    <template slot="title">
                        <div style="width:60px;height:30px;display:inline-block;margin-top:10px;" v-if="!mobiletype">
                            <img :src="item.img">
                        </div>
                        <div class="poolTitle" style="width:138px;">
                            <span v-if="mobiletype">商家：</span>
                            {{item.business_name}}
                        </div>
                        <div class="poolTitle" style="width:138px;" v-if="mobiletype">
                            <span v-if="mobiletype">收货信息：</span>
                            {{item.address.transport_or_not == '1'?"转运":"普通"}}<span class="line"></span>{{item.address.business_or_private == '2'? "私人":"商业"}}<span class="line"></span>{{item.conditions.response_hours}}
                        </div>
                        <div class="poolTitle" style="width:175px;">
                            <span v-if="mobiletype">金额：</span>
                            <span class="totlePrice">{{item.subtotal_price | currency(item.currency_symbol)}}</span>* {{item.conditions.rate}}
                        </div>
                        <div style="width:60px;height:30px;display:inline-block;margin-top:10px;" v-if="!mobiletype">
                            <img :src="item.addressImg">
                        </div>
                        <div class="poolTitle" style="width:120px;" v-if="!mobiletype">
                            {{item.address.transport_or_not == '1'?"转运":"普通"}}<span class="line"></span>{{item.address.business_or_private == '2'? "私人":"商业"}}
                        </div>
                        <div class="poolTitle" style="width:100px;" v-if="!mobiletype">
                            {{item.conditions.response_hours}}
                        </div>
                        <div class="poolTitle" style="width:64px; float: right; margin-right: 17px;" v-if="!mobiletype">
                            {{item.receipt}}
                        </div>
                    </template>
                    <div class="goods">
                        <div class="buyer">
                            下单说明：<p style="display:inline-block;">{{item.conditions.check_full_goods ? '部分商品缺货时仍可下单' : '部分商品缺货时不能下单'}}</p>
                            <p v-if="item.conditions.remark" class="clearfix" style="margin-top: 5px;">
                                <span style="display:inline-block;float:left;">备注：</span>
                                <span style="display:inline-block;width:140px;float:left;">{{item.conditions.remark}}</span>
                            </p>
                        </div>
                        <div class="left-content">
                          <div class="weeCtCoverBeforeDeal" v-if="item.voucher_list && item.voucher_list.length > 0 ">
                            <div class="coverMore" v-if="item.voucher_list.length > 3"></div>
                            <GeminiScrollbar v-if="activeName==index" forceGemini autoshow class>
                              <div
                                      class="ctCover"
                                      :style="{width: `${item.voucher_list.length * (screenWidth > 1024 ? 130 : 90) + 15}px`}"
                              >
                                <div
                                        class="cover"
                                        :style="{background: `url('${cover.url}') center no-repeat`}"
                                        v-for="(cover, $index) in item.voucher_list"
                                        :key="$index" @click="enlarge(cover.url)"
                                >
                                </div>
                              </div>
                            </GeminiScrollbar>
                          </div>
                            <!--<div class="weeCtCoverBeforeDeal" v-if="item.other_image_list && item.other_image_list.length > 0 ">
                                <div class="coverMore" v-if="item.other_image_list.length > 3"></div>
                                <GeminiScrollbar forceGemini autoshow class>
                                    <div
                                            class="ctCover"
                                            :style="{width: `${item.other_image_list.length * 90 + 15}px`}"
                                    >
                                        <div
                                                class="cover"
                                                :style="{background: `url('${$cover}') center no-repeat`}"
                                                v-for="($cover, $index) in item.other_image_list"
                                                :key="$index" @click="enlarge($cover)"
                                        >

                                        </div>
                                    </div>
                                </GeminiScrollbar>
                            </div>-->
                            <div class="goodsList" v-for="(line,index) in item.goods_list" :key="index">
                                <div class="img-container">
                                    <a :href='line.website.substr(0,7).toLowerCase() == "http://" || line.website.substr(0,8).toLowerCase() == "https://" ? line.website : "http://"+ line.website' target="_blank">
                                    <img v-if="line.picture" :src="line.picture"/>
                                    <img v-else src="https://pic.joyorders.com/blank.png"/>
                                    <span class="goodsNum" v-if="line.number>1">{{line.number}}</span>
                                    </a>
                                </div>
                                <div class="order-des">
                                    <p class="name" style="margin-bottom:8px;"><a :href='line.website.substr(0,7).toLowerCase() == "http://" || line.website.substr(0,8).toLowerCase() == "https://"  ? line.website : "http://"+ line.website' target="_blank">{{showProductName(line)}}</a></p>
                                    <!-- <p style="margin-bottom:8px;"><span>规格：</span>{{line.spec}}</p> -->
                                    <div class="spec">
                                      <span v-show="!line.isHideSpecLabel">规格：</span>
                                      <span v-html="formatSpec(line.spec,line)"></span>
                                    </div>
                                    <div v-if="line.discounted_price !== line.price">
                                    <a class="order-price">{{(line.discounted_price)|currency(item.currency_symbol)}}</a>
                                    <del class="order-price"> {{(line.price)|currency(item.currency_symbol)}}</del>
                                    </div>
                                    <div v-if="line.discounted_price == line.price">
                                    <p class="order-price"> {{(line.price)|currency(item.currency_symbol)}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="right-operation">
                            <el-button @click="take_by_single(item)" type="info" style="width:177px; height:50px;border-radius:2px;" class="block btn-18 mobile-button" :class="item.operation?'':'disabled'">{{item.buttonText}}</el-button>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
        </div>
        <el-dialog v-if="completion" class="el-dialog-sm el-dialog-sm-h3" :visible.sync="completion" width="90%" @close="completion = false">
            <div class="text-center redirct">
                <p>
                  <template v-if="result.indexOf('接单成功')>-1">
                    <i class="ico ico-paysucces completion"></i>
                  </template>
                  <template v-else>
                    <div class="fail">
                      <i class="el-icon-error" style="font-size: 78px;color: #FF4650;"></i>
                    </div>
                  </template>
                </p>
                <p>{{result}}</p>
            </div>
        </el-dialog>
        <el-dialog  class="el-dialog-sm el-dialog-sm-h3" :close-on-click-modal="false" :visible.sync="notSingle" width="90%" @close="notSingle = false">
            <div class="text-center redirct">
                <p>只有下单人身份才可以接单,请联系客服开通权限</p>
            </div>
        </el-dialog>

    </div>
    <mobilefooter v-if="mobiletype"></mobilefooter>
    <ft v-else class="ft"></ft>
        <el-dialog v-if="dialogBgPicture" :visible.sync="dialogBgPicture" width="50%"  @close="dialogBgPicture = false" append-to-body>
            <img :src="dialogBgPictureUrl" style="width: 100%;margin-bottom:25px;">
        </el-dialog>
    </div>
</template>
<script>
import hd from '../../../components/Header'
import ft from '../../../components/Footer'
import Loading from '../../../components/Loading'
import mobilefooter from '../../../components/mobilefooter'
import { COUNTRIES, CURRENCIES,specOrder,SPEC_MAPPER } from '../../../services/constant'
import Empty from './Empty'
import api from '../../../services/api.js'
import {errorMessage} from '../../../services/error.js'
import {showProductName,formatSpec} from '../../../services/tools.js'

let _ = require('lodash')
let $ = require('jQuery')


export default {
  name: 'Snatched',
  components: {
    Empty: Empty,
    hd: hd,
    mobilefooter: mobilefooter,
    ft: ft,
    Loading: Loading
  },
  data () {
    return {
      showProductName:showProductName,
      formatSpec:formatSpec,
      screenWidth: document.body.clientWidth,
      mobiletype: false,
      loading: true,
      COUNTRIES: COUNTRIES,
      CURRENCIES: CURRENCIES,
      area: null,
      activeName: '1',
      currency: null,
      business: null,
      limit: 5,
      poolList: [],
      completion: false,
      result: '', // 接单结果
      rotate: false,
      has_single: null,
      notSingle: false,
      timer: false,
      dialogBgPictureUrl: ``,
      dialogBgPicture: false,
      volumnOn:true
    }
  },
  created () {
    if (document.body.clientWidth < 1024) {
      this.mobiletype = true
    }
    if(this.$localStorage.get('volumnWarning'))
      this.volumnOn=this.$localStorage.get('volumnWarning')=='1'?true:false
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  computed: {
    single_type () {
	    return this.$store.state.single_type
    },
  },
  beforeDestroy(){
    this.endPoolListInterval()
  },
  methods: {
    endPoolListInterval(){
      if(this.$localStorage.get('pooltimer')){
        clearInterval(+this.$localStorage.get('pooltimer'))
        this.$localStorage.remove('pooltimer')
      }
    },
    getPoolListInterval(){
      if(this.$localStorage.get('single_type')=='1'){
        if(this.$localStorage.get('pooltimer')){
          clearInterval(+this.$localStorage.get('pooltimer'))
          this.$localStorage.remove('pooltimer')
        }
        if(this.$localStorage.get('token')){
          let timer=setInterval(()=>{
            this.getPoolList()
          },5000)
          this.$localStorage.set('pooltimer',timer)
        }
      }
    },
    switchVolumn(){
      let t=!this.volumnOn
      this.volumnOn=t
      if(!t){
        let a=document.getElementById('alertaudio');
        a.currentTime = 0;
	      a.pause();
      }
      this.$localStorage.set('volumnWarning',t?'1':'0')
    },
    handleAccord(e){
      console.log(e)
    },
    enlarge (item) {
      this.dialogBgPictureUrl = item
      this.dialogBgPicture = true
      // this.$forceUpdate()
    },
    async getPoolList () {
      let query = {
        limit: this.limit,
        area: this.area,
        currency: this.currency,
        business_name: this.business
      }
      let res = await api.getPoolList(this, query)
      if (res.body.status == 'ok') {
        this.loading = false
        let poolList = res.body.result
        _.each(poolList, item => {
          item.receipt = '待接单'
          item.operation = true
          item.buttonText = '确认接单'
          _.each(this.COUNTRIES, list => {
            if (item.business.country == list.value) {
              if (list.img) {
                item.img = list.img
              }
            }
            let country = list.name + '(' + list.value + ')'
            if (item.address.country == country) {
              item.addressImg = list.img
            }
          })
        })
        this.poolList = poolList

        let a=document.getElementById('alertaudio');
        if(poolList.length){
          if(this.single_type=='1' && this.volumnOn)
            a.play()
          else{
            a.currentTime = 0;
	          a.pause();
          }
            
        }
        else{
          a.currentTime = 0;
	        a.pause();
        }

        setTimeout(() => {
          this.rotate = false
        }, 500)
      }
    },
    changeArea (val) {
      this.area = val
      this.getPoolList()
      this.getPoolListInterval()
    },
    changeCurrency (val) {
      this.currency = val
      this.getPoolList()
      this.getPoolListInterval()
    },
    async querySearch (queryString, cb) {
      let query = {
        keyword: queryString
      }
      let res = await api.getPoolBusinessList(this, query)
      let businessList = []
      _.each(res.body.result, item => {
        businessList.push({
          value: item.name
        })
      })

      cb(businessList)
    },
    handleSelect (item) {
      this.business = item.value
      this.getPoolList()
      this.getPoolListInterval()
    },
    refresh () {
      if (this.rotate) {
        return
      }
      this.getPoolList()
      this.getPoolListInterval()
      this.rotate = true
    },
    async take_by_single (item) {
      let token = this.$localStorage.get('token')
      if (!token) {
        this.dialogFormVisible = false
        if (window.innerWidth <= 768) {
          this.$store.commit('showGlobalDialog', 'loginVisible')
        } else {
          window.location.href = '/login'
        }
        return
      }
      let info = await api.getUserInfo(this)
      this.has_single = info.body.result.has_single
      if (this.has_single == '0') {
        this.notSingle = true
        return
      }
      if (!item.operation) {
        return
      }
      if (item.buttonText == '接单中...') {
        return
      } else {
        item.buttonText = '接单中...'
      }
      let res = await api.post(this, {
        path: 'order.php',
        api: 'take_by_single',
        data: {
          order_id: item.id,
          update_time: item.update_time,
          from_pool: 1
        },
        loading: 'loading'
      })
      res = res.body
      if (res.status == 'ok') {
        item.operation = false
        item.receipt = '已接单'
        this.result = '您已接单成功!'
        this.completion = true
        item.buttonText = '确认接单'
      } else {
        item.operation = true
        item.receipt = '任务失效'
        this.result = errorMessage[res.result]?errorMessage[res.result]:'数据错误'
        this.completion = true
        item.buttonText = '确认接单'
      }
    }
  },
  watch: {
    single_type(val){
      if(val!=0)
        this.getPoolList()
      if(val==1)
        this.getPoolListInterval()
    },
    screenWidth (val) {
      if (!this.timer) {
        this.screenWidth = val
        console.log(this.screenWidth)
        if (val <= 1024) {
          this.mobiletype = true
        } else {
          this.mobiletype = false
        }
        console.log(this.mobiletype)
        this.timer = true
        let that = this
        setTimeout(function () {
          // that.screenWidth = tha t.$store.state.canvasWidth
          that.timer = false
        }, 400)
      }
    }
  }

}

</script>
<style scoped lang="scss">
  @font-face {
  font-family: "iconfont"; /* Project id 2668685 */
  /* Color fonts */
  src: 
       url('../../../assets/iconfont/iconfont.woff2?t=1626081681400') format('woff2'),
       url('../../../assets/iconfont/iconfont.woff?t=1626081681400') format('woff'),
       url('../../../assets/iconfont/iconfont.ttf?t=1626081681400') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-icon-joyordervolumn:before {
  content: "\e61a";
}

.el-icon-joyordervolumn-mute:before {
  content: "\e63e";
}
.snatched {
    margin: 0 auto 60px;;
    margin-top: 180px;
    // width: 914px;
    padding: 0 20%;

    .empty {
        overflow: hidden;
        clear: both;
        .empty-content {
            margin-top: 127px;

        }
    }

    .toggle {
        width: 210px;
        margin-right: 20px;
        &:last-child{
          margin-right:0px;
        }

        .el-select {
            width: 100%;
        }
        .el-autocomplete {
            width: 100%;
        }
    }
    .button {
        .refresh {
            width:98px;
            height:40px;
            background:rgba(243,243,249,1);
            border-radius:3px;
            border:1px solid rgba(222,226,236,1);
            padding: 5px 2px;
            cursor: pointer;

            .refreshIcon {
                display: inline-block;
                width:30px;
                height:30px;
                vertical-align: middle;
                transition: transform 0.5s;
                background: url('../../../ico/refresh.png') ;
                background-size: cover;
            }
            @keyframes refresh {
                0% {  transform: rotate(0deg); }
                100% {  transform: rotate(360deg);  }
            }
            .rotate {
                animation: refresh 1s linear infinite;
            }
        }
    }
    .titleList {
        margin-top: 26px;
        padding: 17px 40px 17px 20px;

        .title {
            display: inline-block;
            height: 20px;
            line-height: 20px;
            color: #666666;
            font-size: 14px;
        }
    }
    .pool {
        img {
            // height: 100%;
            width: 45px;
            // height: 30px;
        }
        .poolTitle {
            display: inline-block;
            color: #333333;
            font-size: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            vertical-align: top;

            .totlePrice {
                display: inline-block;
                font-size: 20px;
                margin-right: 5px;
                vertical-align: bottom;
            }
            .line {
                width:2px;
                height:16px;
                border:1px solid #999999;
                margin-right: 8px;
                margin-left: 8px;
            }
        }
        .goods {
            padding: 19px 40px 0 21px;
            overflow: hidden;

            .buyer {
                color: #888888;
                font-size: 14px;
            }

            .left-content {
                float: left;
                width: 60%;
                .goodsList {
                    margin-top: 15px;
                    float: left;
                    width: 100%;
                    .img-container {
                        float: left;
                        width: 120px;
                        height: 120px;
                        margin-right: 20px;
                        overflow: hidden;
                        a {
                        position: relative;
                        display: block;
                        width: 120px;
                        height: 120px;

                        .goodsNum{
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            display: inline-block;
                            height: 20px;
                            width: 20px;
                            border: 1px solid #979797;
                            border-radius: 50%;
                            text-align: center;
                            font-size: 10px;
                            line-height: 18px;
                            color: #333;
                            background: #fff;
                        }
                        }

                        img {
                            height: 120px;
                            width: 120px;
                            object-fit: contain;
                        }
                    }

                    .order-des {
                        float: left;
                        position: relative;
                        min-height: 120px;
                        width: calc(100% - 140px);

                        .order-price{
                        font-size: 18px;
                        line-height: 24px;
                        color: black;
                        margin: 0;
                        }

                        a.order-price {
                        color: #FF0000;
                        font-size: 18px;
                        }

                        del.order-price {
                        color: #9B9B9B;
                        font-size: 18px;
                        }
                        p {
                            word-break: break-all;

                            a {
                                color: #333333;
                                word-break: break-all;
                            }

                            span {
                            }
                        }
                    }
                }
            }
            .right-operation {
                float: right;

                .disabled {
                    width:177px;
                    height:50px;
                    background: #BABABB !important;
                    border: none;
                }
            }
        }
    }
    .redirct {
        font-size:24px;
        line-height:33px;
        padding-bottom: 70px;

        .completion {
            width:76px;
            height:76px;
            background-image: url('../../../ico/blueSucccess@2x.png');
            background-position: 0 0;
            background-size: contain;
        }
        .fail {
            width:76px;
            height:76px;
            margin: 0 auto;
            border-radius: 50%;

            img {
                height: 33px;
                margin: 21px auto;
            }
        }
        p {
            color: #333333;
            font-size: 18px;
            margin-top: 45px;
        }
    }

} 
    @media screen and (min-width: 1026px){
      .snatched{
        .toggleList{
          display:flex;
          justify-content: space-between;
          .toggleGroup{
            display:flex;
            align-items: center;
          }
        }
      }
    }
    @media screen and (max-width:1375px){
        .snatched {
            padding: 0 15%;
        }
    }
    @media screen and (max-width:1200px){
        .snatched {
            padding: 0 10%;
        }
    }
    @media screen and (max-width:1025px){
        .snatched {
            padding: 0 10px;
            margin-top: 100px;
            .toggleList {
                display:block;
                padding-left: 0 !important;
                .toggleGroup{
                  display:block;
                  .warningWrapper{
                    float: left;
                    position: relative;
                    top: 10px;
                    margin-right: 20px;
                  }
                }
                .toggle{

                    width: 100%;
                    margin-bottom: 20px;
                }
            }

            .button {
                float: left;
            }

            .pool {
                margin-top: 20px;
                .poolTitle {
                    display: block;
                    width: 250px !important;
                    font-size: 14px;
                }
            }
        }
    }
    @media screen and (max-width:750px){
        .snatched {
            .pool {

                .goods  {

                    .left-content {
                        width: 100%;
                        margin-bottom: 20px;

                        .goodsList {

                            .order-des {
                                float: right !important;
                                width: 50% !important;
                            }
                        }
                    }

                    .right-operation {
                        .mobile-button {
                            width: 268px !important;
                        }
                    }
                }
            }
        }
    }
.weeCtCoverBeforeDeal {
    position: relative;
    margin-top:15px;
    /*width: 380px;*/
    width: 310px;
    /*width: 430px;*/
    height: 135px;

    .coverMore{
        position: absolute;
        right: 0;
        top: 0;
        width: 50px;
        height: 120px;
        background-image: linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.25), rgba(255,255,255,.75), rgba(255,255,255,.90), white);
        z-index: 1;
    }
    .ctCover{
        height: 120px;
        /*width: 3700px;*/
        display: flex;
        /*flex-wrap: nowrap;*/
        .cover {
            /*display: inline-block;*/
            width: 120px;
            height: 120px;
            margin-right: 10px;
            background-size: contain !important;
            &:last-of-type{
                margin-right: 25px;
            }
            cursor: pointer;
        }
        /*.gm-scroll-view{*/
        /*    display: flex;*/
        /*}*/
    }
}
.spec{
  display: flex;
  word-break: break-all;
  color: #888888;
  line-height: 24px;
  span {
    display: block;
  }
}
.volumn{
  transform: scale(1.5);
  cursor: pointer;
  margin-left:5px;
}
</style>
<style lang="scss">
    /*.weeCtCoverBeforeDeal{*/
    /*.gm-scroll-view{*/
    /*    width: 310px !important;*/
    /*    height: 95px !important;*/
    /*}*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/pages/orders/snatch/snatch.vue